import { Component, Input, ContentChild, QueryList, ElementRef, TemplateRef} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-card-info',
  standalone: true,
  imports: [ NgTemplateOutlet ],
  templateUrl: './card-info.component.html',
  styleUrl: './card-info.component.css'
})
export class CardInfoComponent {
  @ContentChild('titleTemplate')
  titleTemplate?: TemplateRef<any> = undefined;

  @Input()
  cardTitle: string = 'title';

  @Input()
  titleClass: string = 'text-start';

  @Input()
  contentClass: string = '';

  @Input()
  containerClass: string = '';

  @Input()
  iconCard: string = '';
  
  @Input()
  hasTitle: boolean = true;

  ngOnInit() {
    console.log('ngOnInit!');
  }
}
